import React, { useEffect, useState } from "react";
import ReactPDF, {
	Page,
	Text,
	View,
	Document,
	StyleSheet,
	PDFViewer,
} from "@react-pdf/renderer";
import { useSearchParams } from "react-router-dom";
import ataEncaminhamentosService from "services/AtaEncaminhamentosService";
import userService from "services/UserService";
import moment from "moment";
import ataService from "services/AtaService";

const styles = StyleSheet.create({
	page: {
		flexDirection: "column",
		padding: 30,
	},
	section: {
		margin: 10,
	},
	headerSection: {
		margin: 6,
	},
	textTitle: {
		fontSize: 10,
		fontFamily: "Helvetica",
		marginBottom: 2,
	},
	textDescription: {
		fontSize: 10,
		fontFamily: "Helvetica",
		marginTop: 0,
	},

	header: {
		borderTop: "none",
	},
	headerText: {
		fontFamily: "Helvetica-Bold",
	},
	table: {
		width: "100%",
	},
	row: {
		display: "flex",
		flexDirection: "row",
		borderTop: "1px solid #EEE",
		paddingTop: 8,
		paddingBottom: 8,
		fontSize: 10,
	},
	row1: {
		width: "11%",
		marginRight: 5,
	},
	row2: {
		width: "52%",
		marginRight: 5,
	},
	row3: {
		width: "13%",
		marginRight: 5,
	},
	row4: {
		width: "11%",
		marginRight: 5,
	},
	row5: {
		width: "13%",
		marginRight: 5,
	},
});

function getWindowDimensions() {
	const { innerWidth: width, innerHeight: height } = window;
	return {
		width,
		height,
	};
}

function useWindowDimensions() {
	const [windowDimensions, setWindowDimensions] = useState(
		getWindowDimensions(),
	);

	useEffect(() => {
		function handleResize() {
			setWindowDimensions(getWindowDimensions());
		}

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return windowDimensions;
}

const Infos = ({ name, description, responsibles, encaminhamentos }) => {
	return (
		<Document>
			<Page size="A4" style={styles.page}>
				<View style={styles.headerSection}>
					<Text style={[styles.textTitle, styles.headerText]}>Nome da Ata</Text>
					<Text style={styles.textDescription}>{name}</Text>
				</View>
				{description && (
					<View style={styles.headerSection}>
						<Text style={[styles.textTitle, styles.headerText]}>Descrição</Text>
						<Text style={styles.textDescription}>{description}</Text>
					</View>
				)}
				<View style={styles.section}>
					<View style={styles.table}>
						<View style={[styles.row, styles.header]}>
							<Text style={[styles.row1, styles.headerText]}>Data</Text>
							<Text style={[styles.row2, styles.headerText]}>Encaminhamentos</Text>
							<Text style={[styles.row3, styles.headerText]}>Responsável</Text>
							<Text style={[styles.row4, styles.headerText]}>Prazo</Text>
							<Text style={[styles.row5, styles.headerText]}>Status</Text>
						</View>
					</View>
					{encaminhamentos.map((row, i) => (
						<View key={i} style={styles.row} wrap={false}>
							<Text style={styles.row1}>
								{moment(row.created_at).format("DD/MM/YYYY")}
							</Text>
							<Text style={styles.row2}>{row.referrals}</Text>
							<Text style={styles.row3}>
								{
									responsibles?.find(
										(option) =>
											option.value === row.responsible_id,
									)?.label
								}
							</Text>
							<Text style={styles.row4}>
								{moment(row.deadline).format("DD/MM/YYYY")}
							</Text>
							<Text style={styles.row5}>{row.status}</Text>
						</View>
					))}
				</View>
			</Page>
		</Document>
	);
};

const PrintPdf = () => {
	const { height, width } = useWindowDimensions();
	const [queryParameters] = useSearchParams();
	const ataId = queryParameters.get("id");
	const data = queryParameters.get("data");
	const selectedEncaminhamentos = JSON.parse(data);
	const [selectedAta, setSelectedAta] = useState({});
	const [usuarios, setUsuarios] = useState([]);

	useEffect(() => {
		if (ataId) {
			getInfos();
			getUsuarios();
		}
	}, [ataId]);

	async function getInfos() {
		try {
			const response = await ataService.getById(ataId);
			setSelectedAta(response);
		} catch (error) {
			console.log(error);
		}
	}

	async function getUsuarios() {
		try {
			const response = await userService.get();
			const funcoes = response.map((item) => {
				return {
					value: item.id,
					label: item.lastname,
				};
			});
			setUsuarios(funcoes);
		} catch (error) {
			console.log(error);
		}
	}

	if (!selectedAta)
		return (
			<span
				className="spinner-border spinner-border-sm mr-1"
				style={{ marginRight: 10 }}
			></span>
		);

	return (
		<PDFViewer width="100%" height={height - 7}>
			<Infos
				name={selectedAta.name}
				description={
					selectedAta.description && selectedAta.description.trim() !== ""
						? selectedAta.description
						: null
				}
				encaminhamentos={selectedEncaminhamentos}
				responsibles={usuarios}
			/>
		</PDFViewer>
	);
};
export default PrintPdf;
